import { useEffect, useRef, useState, useMemo } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const calledRef = useRef(false);
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');

    // Memoize the token so it doesn't re-compute each render
    const token = useMemo(() => searchParams.get('token'), [searchParams]);

    useEffect(() => {
        if (calledRef.current) return;            // ⛔️ prevents double-run in StrictMode
        calledRef.current = true;

        const verify = async () => {
            if (!token) {
                setMessage('Invalid token');
                setLoading(false);
                return;
            }

            try {
                // Always URL-encode the token to be safe
                const { data } = await api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`);
                setSuccess(true);
                setMessage(data.message);

                // Optional: remove token from the URL to avoid re-verification on re-mounts
                // We replace the history entry so back button works naturally.
                navigate('/verify-email', { replace: true });
            } catch (error) {
                setSuccess(false);
                setMessage(error.response?.data?.message || 'Verification failed');
            } finally {
                setLoading(false);
            }
        };

        verify();
    }, [token, navigate]);

    if (loading) return <div className="text-center mt-20">Verifying...</div>;

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-xl text-center border border-gray-200 dark:border-gray-700">
                <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
                    {success ? 'Email Verified!' : 'Verification Failed'}
                </h2>
                <p className="text-gray-700 dark:text-gray-300 mb-6">{message}</p>
                {success && (
                    <Link
                        to="/signin"
                        className="inline-block px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700"
                    >
                        Proceed to Login
                    </Link>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;